var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-back" },
    [
      _c("div", { staticClass: "row topmainrow" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c("div", { staticClass: "topmainlayer card" }, [
              _c("div", { staticClass: "main-user-title" }, [
                _vm._v(" " + _vm._s(_vm.userName) + "님, 안녕하세요"),
                _c("br"),
                _c("span", { staticClass: "main-user-title-m" }, [
                  _vm._v("Smart Work를 시작하세요"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row topmainbtns" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sop/swp/safeWorkPermit")
                        },
                      },
                    },
                    [_vm._m(0)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sop/cto/cto")
                        },
                      },
                    },
                    [_vm._m(1)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/sai/patrol/patrol")
                        },
                      },
                    },
                    [_vm._m(2)]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 topcarddiv",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "maincard card",
                      on: {
                        click: function ($event) {
                          return _vm.goPage("/env/ptr/envPatrol")
                        },
                      },
                    },
                    [_vm._m(3)]
                  ),
                ]
              ),
              _c("div", { staticClass: "col-12 topcarddiv" }, [
                _c("div", { staticClass: "card noti-cardcontents" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      staticStyle: {
                        "border-radius": "0.4375rem 0.4375rem 0 0",
                      },
                    },
                    [
                      _vm._v(" 개선관리 "),
                      _c(
                        "div",
                        {
                          staticClass: "card-more",
                          on: {
                            click: function ($event) {
                              return _vm.goPage("/sop/ibm/impr")
                            },
                          },
                        },
                        [_vm._v("more")]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "card-body no-padding-card" },
                    [
                      _c("q-table", {
                        attrs: {
                          grid: "",
                          title: "",
                          data: _vm.data.imprList,
                          "hide-header": "",
                          "hide-bottom": "",
                          "rows-per-page-options": [0],
                          "virtual-scroll": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                                  },
                                  [
                                    _c(
                                      "q-card",
                                      {
                                        staticClass:
                                          "mobileTableCardLayer-main",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getDetailPage(
                                              "IMPROVE",
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "q-card-section",
                                          { staticClass: "grid-card-etc" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-grid-etc-title",
                                              },
                                              [_vm._v(" 요청부서 : ")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "text-grid-etc" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.requestDeptName
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  [
                                                    props.row.completeDateOver >
                                                    0
                                                      ? _c("q-badge", {
                                                          attrs: {
                                                            color: "negative",
                                                            label: "지연",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c("br"),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-grid-etc-title",
                                              },
                                              [_vm._v(" 완료 요청일 : ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                class: [
                                                  "text-grid-etc",
                                                  _vm.getColorStatus(
                                                    props.row.ibmStepCd
                                                  ),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.ibmStepName
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "text-grid-etc" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row
                                                        .actionCompleteRequestDate
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                class: [
                                                  "text-grid-etc",
                                                  _vm.getColorStatus(
                                                    props.row.ibmStepCd
                                                  ),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.ibmStepName
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.data.imprList.length === 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                            },
                            [
                              _c(
                                "q-card",
                                { staticClass: "mobileTableCardLayer-main" },
                                [
                                  _c(
                                    "q-card-section",
                                    {
                                      staticClass: "text-center",
                                      attrs: { horizontal: "" },
                                    },
                                    [
                                      _c(
                                        "q-card-section",
                                        { staticClass: "q-pt-xs" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-grid-title text-grid-titlemain q-mt-sm q-mb-xs",
                                            },
                                            [
                                              _vm._v(
                                                "등록된 개선관리가 없습니다."
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "card noti-cardcontents2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      staticStyle: {
                        "border-radius": "0.4375rem 0.4375rem 0 0",
                      },
                    },
                    [_vm._v(" 공지사항 ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "card-body no-padding-card" },
                    [
                      _c("q-table", {
                        attrs: {
                          grid: "",
                          title: "",
                          data: _vm.data.noticeList,
                          "hide-header": "",
                          "hide-bottom": "",
                          "rows-per-page-options": [0],
                          "virtual-scroll": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                                  },
                                  [
                                    _c(
                                      "q-card",
                                      {
                                        staticClass:
                                          "mobileTableCardLayer-main",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getDetailPage(
                                              "NOTICE",
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "q-card-section",
                                          { staticClass: "grid-card-etc" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: [
                                                  "text-grid-etc",
                                                  _vm.getColorStatus3(
                                                    props.row.noticeClassCd
                                                  ),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.noticeClassName
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-grid-title q-mt-sm q-mb-xs",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(props.row.noticeTitle)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-grid-etc-right",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(props.row.regDtStr) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.data.noticeList.length === 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                            },
                            [
                              _c(
                                "q-card",
                                { staticClass: "mobileTableCardLayer-main" },
                                [
                                  _c(
                                    "q-card-section",
                                    {
                                      staticClass: "text-center",
                                      attrs: { horizontal: "" },
                                    },
                                    [
                                      _c(
                                        "q-card-section",
                                        { staticClass: "q-pt-xs" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-grid-title text-grid-titlemain q-mt-sm q-mb-xs",
                                            },
                                            [
                                              _vm._v(
                                                "등록된 공지사항이 없습니다."
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h5", { staticClass: "title" }, [_vm._v("안전작업허가서")]),
        _c("p", { staticClass: "subs" }, [_vm._v("밀폐/일반")]),
      ]),
      _c("div", { staticClass: "main-card-body-right" }, [
        _c("span", { staticClass: "material-icons text-green-6" }, [
          _vm._v("handyman"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h5", { staticClass: "title" }, [_vm._v("패트롤")]),
        _c("p", { staticClass: "subs" }, [_vm._v("안전보건팀")]),
      ]),
      _c("div", { staticClass: "main-card-body-right" }, [
        _c("span", { staticClass: "material-icons text-red-6" }, [
          _vm._v("fact_check"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h5", { staticClass: "title" }, [_vm._v("점검반")]),
        _c("p", { staticClass: "subs" }, [_vm._v("안전환경 ")]),
      ]),
      _c("div", { staticClass: "main-card-body-right" }, [
        _c("span", { staticClass: "material-icons text-orange-6" }, [
          _vm._v("engineering"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "main-card-body-left" }, [
        _c("h5", { staticClass: "title" }, [_vm._v("패트롤")]),
        _c("p", { staticClass: "subs" }, [_vm._v("환경팀")]),
      ]),
      _c("div", { staticClass: "main-card-body-right" }, [
        _c("span", { staticClass: "material-icons text-indigo-6" }, [
          _vm._v("repeat_on"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }